import {NamaPresenter} from "./NamaPresenter";
import {ChartsDrawer} from "../views/charts/ChartsDrawer";

export class WelcomePresenter extends NamaPresenter {
    start() {
        let that = this;
        let exampleDiv = $("#example.page-content-wrapper");
        exampleDiv.html("");
        that.chartsDrawer = new ChartsDrawer(exampleDiv, "");
        that.chartsDrawer.fetchCharts(that.place.dashBoardId);
    }

}